module.exports = __webpack_public_path__ + "fonts/montserrat-mediumitalic-webfont.595546c.woff";